import { BreakString } from 'foundations-components/transitional/components/BreakString';
import { Button } from 'foundations-components/transitional/components/Button';
import { List } from 'foundations-components/transitional/components/List';
import { ListItem } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import NotOwnedWarning from 'documents-ui/components/NotOwnedWarning';
import * as NotOwnedWarningTypes from 'documents-ui/constants/NotOwnedWarningTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeleteModal = ({
  documentsToDelete,
  onConfirm,
  onReject
}) => {
  const documentName = documentsToDelete.first().get('name');
  const count = documentsToDelete.size;
  return /*#__PURE__*/_jsxs(Modal, {
    size: "auto",
    width: 500,
    use: "danger",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onReject
      }), /*#__PURE__*/_jsx(Text, {
        as: "h2",
        children: /*#__PURE__*/_jsx(BreakString, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteModal.title",
            options: {
              documentName,
              count
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(NotOwnedWarning, {
        type: NotOwnedWarningTypes.DELETE,
        searchResults: documentsToDelete
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "deleteModal.subtitle",
          options: {
            documentName,
            count
          }
        })
      }), /*#__PURE__*/_jsxs(List, {
        styled: true,
        children: [/*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteModal.warnings.sharingNoLongerWorks",
            options: {
              documentName,
              count
            }
          })
        }), /*#__PURE__*/_jsx(ListItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "deleteModal.warnings.reportingRemoved",
            options: {
              documentName,
              count
            }
          })
        })]
      }), /*#__PURE__*/_jsx(Text, {
        marginBlockStart: "400",
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteModal.warnings.cantBeUndone"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "danger",
        onClick: onConfirm,
        "data-selenium-test": "confirm-delete-document-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteModal.confirm",
          options: {
            count
          }
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary-light",
        onClick: onReject,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "deleteModal.cancel"
        })
      })]
    })]
  });
};
export default DeleteModal;